import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../rootReducer";
import axios from "axios";
import { format } from "rut.js";
import axiosInstance from "../../../utils/axiosConfig";

export const fetchDocuments = createAsyncThunk(
  "documentsSignerList/fetch",
  async (data, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;
      const segment = state.documentsSignerList.segmentSelected;
      const documentPendingStatus = state.utils.status.find(
        ({ module, code }) => module === "document" && code === "pending"
      );
      const limit = segment === "pending" ? 1000 : 30;
      const { searchText, statusFilter, createdAtFilter, page, sort, typeFilter, createdByFilter } =
        state.documentsSignerList;
      const skip = limit * (page - 1);
      const { user } = state.userAuthentication;
      const pendingStates = [2, 3, 7]

      const status =
        segment === "pending"
          ? documentPendingStatus?.id
          : statusFilter?.length
            ? statusFilter.map(({ id }) => id)
            : pendingStates;

      const where = {
        author: createdByFilter === "me" ? user?.id : undefined,
        title: { contains: searchText },
        stakeholdersDnis: { contains: format(user?.dni!, { dots: false }) },
        createdAt:
          createdAtFilter?.from && createdAtFilter?.to
            ? { ">=": createdAtFilter.from, "<=": createdAtFilter.to }
            : undefined,
        status,
        category: typeFilter?.length ? typeFilter.map(({ id }) => id) : undefined,
        pendingDnis:
          segment === "pending" ? { contains: format(user?.dni!, { dots: false }) } : undefined,
        source: "migs",
        sourceOrganization: state.userAuthentication.user?.sourceOrganization,
      };

      const listPromise = axiosInstance.get(`${api.baseURL}document`, {
        params: {
          where,
          sort,
          limit,
          skip,
        },
      });
      const countPromise = axiosInstance.post(`${api.baseURL}document/count`, {
        where,
      });

      if (page === 1) {
        const [{ data: list }, { data: count }] = await Promise.all([listPromise, countPromise]);
        return [list, count];
      } else {
        const { data: list } = await listPromise;
        return [list];
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
